import { MeetHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PostMeetData = (descOfMedSup, requestSig, meetObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);
    
    const url = `/Meet`;
    const urlMeetSanction = `/Meet/MeetSanction/${descOfMedSup}/${requestSig}`;
    
    MeetHttpHelper(requestSig.length === 0 ? url : urlMeetSanction, 'POST', meetObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PostMeetData;